
<template>
  <div style="wideth:100%">
    <Header :title="$t('m.SacnQRCode')"></Header>
    <div class="qrcode">
      <qrcode-stream @decode="onDecode" @init="onInit" />
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import { setSignIn, addterminal } from "../../assets/js/url";
import Header from "../header/header";

export default {
  components: { QrcodeStream },

  data() {
    return {
      qrcode: "", 	//二维码里的内容
      error: "", 	//错误信息
      id: "", 		//从二维码内容中截取的id
      paramsInfo: "" //从路由过来的数据 type： signIn; addTerminal
    };
  },
  components: {
    Header
  },
  activated() {
    this.paramsInfo = this.$route.query; //接收参数
  },
  deactivated() {
    this.$destroy(true); //销毁状态
  },
  methods: {
    onDecode(qrcode) {
      this.qrcode = qrcode;	//二维码中的数据内容
      if (this.paramsInfo.type == "signIn" ) {	//扫会议码签到，二维码中内容为会议详情URL，如：https://vc.pgscn.cc:9983/meetingdetail?meetinguuid=3084&id=3084
        if (qrcode.indexOf("id=") == -1) {
          this.$toast(this.$t('m.PlsConfirmQRCode'));
          return;
        }
        var codeArr = qrcode.split("id=");
        this.id = codeArr[codeArr.length - 1]; //二维码中获取会议id
        if (this.id == null || typeof this.id == "undefined") {
          //id为空
          this.$toast(this.$t('m.PlsConfirmQRCode'));
          return;
        }
        this.signIn(this.id);
      } 
	  else if (this.paramsInfo.type == "addTerminal") {	//扫终端码入会，二维码中内容为终端ID，如：21。
		this.addTerminal(qrcode);
      }
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        } else {
          this.error = error.name + "--other error";
        }
      }
    },

    //1.签到
    signIn(meetingId) {
      this.$http
        .post(setSignIn, {
          userId: window.sessionStorage.getItem("UUID"),
          meetingId: meetingId //会议的数据库id
        })
        .then(res => {
          if (res.data.status == 2000) {
            this.$toast(this.$t('m.CheckinOK'));
          } else {
            this.$toast(res.data.data.errorDes);
          }
          //this.$router.go(-1); //回到来时的路
		  this.$router.push("/index");
        });
    },
	
    //2.增加终端
    addTerminal(terminalId) {
      this.$http
        .post(addterminal, {
          userUUId: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: this.paramsInfo.meetingId,
          addTerminaliUUId: terminalId //终端的数据库id
        })
        .then(res => {
          if (res.data.status == 2000) {
            this.$toast(this.$t('m.AddTerminalkOK'));
          } else {
            this.$toast(this.$t('m.AddterminalFail'));
          }
          //this.$router.go(-1); //回到来时的路
		  this.$router.push("/index");
        });
    }
  }
};
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
.qrcode {
  width: 500px;
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/content/sxt.vue